module.exports = __webpack_public_path__ + "img/821.3fbe7f9b.png";